module.exports = __webpack_public_path__ + "0bed9c284fcc10af4c1f29902da64aef.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_4.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_4.png
// module chunks = 40